import { gql } from '__generated__';

export default gql(`
  mutation DeleteTicket($id: ID!) {
    deleteTicket(id: $id)
  }
`);
